import { terminal, UserAgentInfo } from '@/constant/index';
import { commonApi, getShopifyUserId, companyUUID } from '@/service/api';

export function formMonitorSlsLog(eventSpecificParams) {
  const commonParams = {
    companyUuid: companyUUID,
    shopifyUserId: getShopifyUserId(),
    cliTimestamp: Date.now(),
    terminal: terminal ? 'pc' : 'mobile',
    scrWid: window.innerWidth,
    scrHei: window.innerHeight,
    osVersion: UserAgentInfo().osVersion,
    browserBrand: UserAgentInfo().browserBrand,
    browserVersion: UserAgentInfo().browserVersion,
    country: Intl.DateTimeFormat().resolvedOptions().timeZone,
    hostname: window.location.hostname,
    pathname: window.location.pathname
  };

  const params = { ...commonParams, ...eventSpecificParams };

  return commonApi(params, 'form/monitor/slsLog')
    .then((response) => {
      // console.log('数据上报成功');
    })
    .catch((error) => {
      console.error('数据上报失败:', error);
    });
}
